// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";

import { useAppCustomStyles } from "../../assets/theme/custom/hooks";
import { useMaterialUIController } from "../../context";

function SidenavCollapse({ icon, name, active = false, ...rest }: any) {
  const custom = useAppCustomStyles();
  const sidenav = custom.widgets.sidenav;
  const [controller] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;

  const collapseState = {
    active,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
    miniSidenav,
  };

  return (
    <ListItem component="li" disablePadding>
      <Box {...rest} sx={sidenav.collapseItem(collapseState)}>
        <ListItemIcon sx={sidenav.collapseIconBox(collapseState)}>
          {typeof icon === "string" ? (
            <Icon sx={sidenav.collapseIcon(collapseState)}>{icon}</Icon>
          ) : (
            icon
          )}
        </ListItemIcon>

        <ListItemText
          primary={name}
          sx={sidenav.collapseText(collapseState)}
        />
      </Box>
    </ListItem>
  );
}

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default SidenavCollapse;
